module.exports = __webpack_public_path__ + "img/mir.4c836f2a.svg";